'use client';

import React, { useState } from 'react';
import { RootState } from '@/store';
import { useAppSelector } from '@/store/hooks';
import { refreshActiveTable } from '@/store/reducers/table-slice';
import { getUi, hideModal } from '@/store/reducers/ui-slice';
import { Permission } from '@alien-platform/bo-sdk-v2';
import { MethodResponse } from '@alien-platform/cms-bo';
import { Button, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'sonner';

function DeletePermissionModalContent(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);
  const { user } = useSelector((state: RootState) => state.user);
  const content = modal?.content as Permission;

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = (): void => {
    dispatch(hideModal());
  };

  const handleSubmit = async (): Promise<void> => {
    setIsLoading(true);

    try {
      const response = await fetch(`/api/permissions`, {
        method: 'DELETE',
        body: JSON.stringify({
          id: content?.id,
          opId: user?.opId,
          name: content.name,
        }),
      });
      const result: MethodResponse<Permission> = await response.json();
      if (response.ok && result.success) {
        toast.success('Permission deleted successfully!');
        dispatch(hideModal());
        dispatch(refreshActiveTable());
      } else {
        toast.error(result.messages?.[0] || 'Error: 500 | Unable to delete permission item');
      }
    } catch (e) {
      toast.error('Error: 500 | Unable to delete permission item');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack spacing={3}>
      <Typography variant="body2">
        Are you sure you want to delete the permission <strong>{content.name}</strong> ?
      </Typography>
      <Stack direction="row" spacing={3} sx={{ mt: 3, justifyContent: 'initial' }}>
        <Button type="button" color="secondary" onClick={handleClose} sx={{ flex: '1 1 auto' }}>
          Close
        </Button>

        <Button loading={isLoading} onClick={handleSubmit} color="error" sx={{ flex: '1 1 auto' }} variant="contained">
          Delete
        </Button>
      </Stack>
    </Stack>
  );
}

export default DeletePermissionModalContent;
